<template>
	<div class="webOrder">
		<div class="cityName">
			{{province.name}}
		</div>
		<div class="mediaList">
			<div class="media clearfix" v-for='(item, myindex) in webData' v-if='webData'>
				<div class="web-name pull-left" :class='index === myindex ? "text-theme" : ""' @click='changeCurrent(myindex)'>
					{{item.name}}&nbsp&nbsp&nbsp<span class="glyphicon" :class='index === myindex ? "glyphicon-down-slide" : "glyphicon-up-slide"'></span>
				</div>
				<div class="look-over pull-right">
					<a target="_blank" :href='item.previewUrl'>预览</a>
				</div>
				<transition name="slide-fade">
					<div class="media-content" v-if='index === myindex'>
						<div class="web-des">
							域名: {{item.domain}}
						</div>
						<div class="web-des">
							日均IP: {{item.uvIP}}
						</div>
						<div class="web-des">
							日均PV: {{item.showPV}}
						</div>
						<div class="web-des">
							网站简介: {{item.siteIntro}}
						</div>
					</div>
				</transition>
			</div>
			<div v-if='!webData'>
				暂无可预览站点!
			</div>
		</div>
		<div class="page-run">
			<div class="page-left pull-right" @click='changeIndex(1)' v-if='this.totalpage > 1'>
				<span class="glyphicon glyphicon-rect-left"></span>
			</div>
			<div class="page-left pull-right" @click='changeIndex(-1)' v-if='this.totalpage > 1'>
				<span class="glyphicon glyphicon-rect-right"></span>
			</div>
		</div>
		<transition name="modal-fade" v-if='show'>
		    <div class="widget" @click='hideModal'>
		      <div class="modal">
		        <div class="modal-head">温馨提示</div>
		        <div class="modal-body clearfix">
		          <div>暂无可预览站点!</div>
		        </div>
		      </div>
		    </div>
		 </transition>
	</div>
</template>

<script>
	export default {
		props: ['province'],
		data () {
			return {
				page: 1,
				index: 0,
				totalpage: '',
				webData: '',
				show: false,
				webAllData: ''
			}
		},
		watch: {
			province: function (val, oldVal) {
				this.$set(this, 'index', 0)
				this.getOrderData()
			}
		},
		mounted () {
			this.$http.get(this.baseUrl + 'localmedia', {params: {type: 1}})
			.then((res) => {
				this.$set(this, 'webAllData', JSON.parse(res.data).result.datalist || false)
				this.getOrderData()
				if (!this.webData) {
					this.$set(this, 'show', true)
				}
			})
		},
		methods: {
			hideModal () {
				this.$set(this, 'show', false)
			},
			getOrderData (page) {
				console.log(this.weballData)
				this.$set(this, 'webData', this.webAllData[this.province.id] || false)
			},
			changeCurrent (myindex) {
				this.$set(this, 'index', myindex)
			},
			changeIndex (index) {
				let newPage = this.page + index
				if (newPage < 1 || newPage > this.totalpage) {
					newPage = newPage - index
				}
				this.$set(this, 'page', newPage)
				this.getOrderData(this.page)
			}
		}
	}
</script>

<style lang='less'>
	.slide-fade-enter-active {
	  transition: all 0.5s ease;
	}
	.slide-fade-leave-active {
	  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter,
	.slide-fade-leave-active {
	  transform: translateX(200px);
	  opacity: 0;
	}
	a{
		text-decoration: none;
		color: white;
	}
	.webOrder{
		margin-top: 150px;
		float: left;
		width: 400px;
		height: 510px;
		padding: 20px 10px;
		background-color: #f5f4f9;
		.cityName{
			font-size: 18px;
			font-weight: bold;
		}
		.mediaList{
			height: 401px;
			box-sizing: border-box;
			padding-top: 20px;
			.media + .media{
				margin-top: 15px;
			}
			.web-name{
				line-height: 19px;
				cursor: pointer;
				.glyphicon-down-slide{
					color: #4285f4;
				}
				.glyphicon-up-slide{
					color: #333;
				}
				.to-up{
					background-color: #333;
				}
				.to-down{

				}
			}
			.look-over{
				padding: 2px 8px;
				font-size: 12px;
				border-radius: 15px;
				border:1px solid #4285f4;
				background-color: #4285f4;
				color: white;
				cursor: pointer;
			}
			.media-content{
				margin-top: 40px;
				padding: 20px 10px;
				box-sizing: border-box;
				background-color: white;
				font-size: 12px;
				height: 225px;
				.web-des{
					line-height: 18px;
					margin-bottom: 10px;
				}
			}
		}
		.page-run{
			margin-top: 30px;
			.glyphicon:hover{
				color: #4285f4;
			}
			.page-left{
				color: #999;
				text-align: right;
				line-height: 30px;
				width: 20px;
				height: 30px;
				font-size: 18px;
				margin-left: 15px;
				cursor: pointer;
			}
			.page-left:hover{
				color: #4285f4;
			}
		}
}
</style>



// WEBPACK FOOTER //
// weborder.vue?3f4e1898